import React from 'react'
import { faCheck, faList } from '@fortawesome/pro-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Dropdown, Menu } from 'antd'

import styles from './FastActions.module.scss'

interface IActions {
  fastActions: any[]
  fastActionSelected: any
  onFastActionSelected: (value: any) => void
  label: React.ReactNode
}
const FastActions: React.FC<IActions> = ({
  fastActions,
  label,
  fastActionSelected,
  onFastActionSelected,
}) => {
  return (
    <Dropdown
      placement="bottomRight"
      className={`rankmiTable-fastActions-container ml-2 ${
        styles.fastActionsSelect
      } ${fastActionSelected ? styles.active : ''} m-0`}
      overlayClassName="rankmiTable-fastActions"
      overlay={
        <Menu>
          <Menu.Item onClick={() => onFastActionSelected(null)}>
            {label}{' '}
            {fastActionSelected === null ? (
              <FontAwesomeIcon icon={faCheck} />
            ) : (
              <div className={styles.fastActionOffset} />
            )}
          </Menu.Item>
          {fastActions.map(
            ({ label, value, group, disabled: disabledRoot }, indexGroup) =>
              group && group.length ? (
                <Menu.ItemGroup
                  key={`fastActionGroup-${indexGroup}`}
                  title={label}
                >
                  {group.map(
                    (
                      { label, value, disabled = disabledRoot }: any,
                      index: number
                    ) => (
                      <Menu.Item
                        key={`fastAction-${indexGroup}-${index}`}
                        disabled={disabled}
                        onClick={() => onFastActionSelected(value)}
                      >
                        {label}
                        {fastActionSelected === value ? (
                          <FontAwesomeIcon icon={faCheck} />
                        ) : (
                          <div className={styles.fastActionOffset} />
                        )}
                      </Menu.Item>
                    )
                  )}
                </Menu.ItemGroup>
              ) : (
                <Menu.Item
                  key={`action-${indexGroup}`}
                  disabled={disabledRoot}
                  onClick={() => onFastActionSelected(value)}
                >
                  {label}
                  {fastActionSelected === value ? (
                    <FontAwesomeIcon icon={faCheck} />
                  ) : (
                    <div className={styles.fastActionOffset} />
                  )}
                </Menu.Item>
              )
          )}
        </Menu>
      }
    >
      <Button size="small">
        <FontAwesomeIcon icon={faList} />
      </Button>
    </Dropdown>
  )
}

export default FastActions
